module.exports = __webpack_public_path__ + "static/media/pilot04.4a084568.jpg";